document.addEventListener('DOMContentLoaded', trick );
document.addEventListener('DOMContentLoaded', back );

function trick() {
    const bl = /blanc/i;
    const vd = /^\-/;
    let books = document.getElementsByTagName('figcaption');
    for ( let i = 0; i < books.length; i++) {
        let info = books[i].textContent;
        let img = books[i].parentNode;
        if ( bl.test(info)) {
            img.classList.add('blanc');
        }
    }

   let titre = document.getElementsByClassName('post-content-title');
   let texte = titre[0].textContent
   if (vd.test(texte)) {
       titre[0].classList.add('notitre');
       titre[0].parentNode.classList.add('notitrecont')
    }

}

function back() {
    document.getElementById("back").addEventListener('click', function() {
    if ( window.history.length > 1 ) {
        window.history.back();
    }
    });
}
